import { render, staticRenderFns } from "./wawayfs.vue?vue&type=template&id=03abe48a"
import script from "./wawayfs.vue?vue&type=script&lang=js"
export * from "./wawayfs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports